import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';

/**
 * Academy header component
 * Shows breadcrumb navigation and optional progress bar
 *
 * Usage:
 * <ut-academy-header
 *   title="Track: Testing in the uTest Platform"
 *   [showProgress]="true"
 *   [currentProgress]="3"
 *   [totalItems]="5"
 *   (backClick)="onBackClick()">
 * </ut-academy-header>
 */
@Component({
  selector: 'ut-academy-header',
  templateUrl: './academy-header.component.html',
  styleUrls: ['./academy-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AcademyHeaderComponent {
  @Input() title: string = '';
  @Input() showProgress: boolean = true;
  @Input() currentProgress: number = 0;
  @Input() totalItems: number = 0;
  @Input() backLabel: string = 'Return to Course Catalog';

  @Output() backClick = new EventEmitter<void>();

  onBackButtonClick(): void {
    this.backClick.emit();
  }

  get progressPercentage(): number {
    if (this.totalItems === 0) return 0;
    return Math.round((this.currentProgress / this.totalItems) * 100);
  }
}
